import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_party_supplies: FaireCategoryEntity = {
  token: "catalog_cat_party-supplies",
  type: "category",
  name: "Party supplies",
  count: 77,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
